import {
  Card,
  CardHeader,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from '@material-ui/core';
import * as React from 'react';
import { Description } from '@material-ui/icons';
import { grey } from '@material-ui/core/colors';
import { getUserData } from 'lib/Helper/Auth';
import { useHistory } from 'react-router-dom';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  clickableListItem: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: grey[200],
    },
  },
}));

export const PlaygroundView: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const user = getUserData();
  const hasInterviewReportGeneratorAccess = user?.permissions?.includes(
    'interview_report_generator',
  );
  const hasCvCritiqueAccess = user?.permissions?.includes('cv_critique');
  const hasVacancyMatcherAccess =
    user?.permissions?.includes('vacancy_matcher');

  return (
    <Grid container>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title="Playground"
            subheader="A space to try out experimental tools and features."
          />

          <Alert severity="warning">
            Features here are experimental, may not work correctly, and are not
            actively maintained. They are test features for trial purposes only.
          </Alert>

          <List>
            {/* {hasHelpBotAccess && (
              <ListItem
                className={classes.clickableListItem}
                onClick={() => {
                  history.push('/playground/help');
                }}
              >
                <ListItemIcon>
                  <Assistant />
                </ListItemIcon>
                <ListItemText
                  primary="Talexio Help Center Bot"
                  secondary="AI-powered assistant for answering questions on Talexio."
                />
              </ListItem>
            )} */}
            {hasInterviewReportGeneratorAccess && (
              <ListItem
                className={classes.clickableListItem}
                onClick={() => {
                  history.push('/playground/interview-report-generator');
                }}
              >
                <ListItemIcon>
                  <Description />
                </ListItemIcon>
                <ListItemText
                  primary="Interview Report Generator"
                  secondary="Generate interview questions or reports from a resume."
                />
              </ListItem>
            )}

            {hasCvCritiqueAccess && (
              <ListItem
                className={classes.clickableListItem}
                onClick={() => {
                  history.push('/playground/cv-critique');
                }}
              >
                <ListItemIcon>
                  <Description />
                </ListItemIcon>
                <ListItemText
                  primary="CV Critique"
                  secondary="Generate a critique on candidate's CV."
                />
              </ListItem>
            )}

            {hasVacancyMatcherAccess && (
              <ListItem
                className={classes.clickableListItem}
                onClick={() => {
                  history.push('/playground/vacancy-matcher');
                }}
              >
                <ListItemIcon>
                  <Description />
                </ListItemIcon>
                <ListItemText
                  primary="Matching"
                  secondary="Find the candidates who best fit a vacancy, or the open vacancies that best fit a candidate."
                />
              </ListItem>
            )}
          </List>
        </Card>
      </Grid>
    </Grid>
  );
};
